export const ADDITIONAL_FEE_TYPE = {
	CATEGORY: 'category',
	PRODUCT: 'product',
	POSTCODE: 'postcode',
};
